// extracted by mini-css-extract-plugin
export default {"machineLearning":"_2tye8Bv4P1sbGEiqyvO5Vy","content":"_1uyulYbq9Zt0_Q6Lh5-M7J"};